import axios from "axios";

const instance = axios.create();
instance.interceptors.request.use(
    config => {
        if (config.method === "post") {
            config.data = JSON.stringify(config.data);
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

function YSToken(map) {
    this.map = map || [];
    this.cache = {};
}
YSToken.prototype.updateMap = function(device) {
    let newArray = [];
    if (Array.isArray(device)) {
        newArray = [...device];
    } else {
        newArray = [device];
    }
    let filterArray = newArray.filter(camera => {
        return (
            this.map.filter(item => {
                return item.id == camera.id;
            }).length == 0
        );
    });
    this.map = [...this.map, ...filterArray];
};
YSToken.prototype.getToken = function(camera_device_id) {
    return new Promise((resolve, reject) => {
        let obj = this.map.filter(item => {
            return item.id == camera_device_id ? true : false;
        });
        if (obj.length == 0) {
            reject("无该appKey信息");
        } else {
            let ys = obj[0];
            if (typeof this.cache[ys["appKey"]] == "undefined") {
                this.getYsAccessToken(ys["appKey"], ys["appSecret"]).then(res => {
                    if (res.value) {
                        this.cache[ys["appKey"]] = res.data;
                        resolve(res.data);
                    } else {
                        reject(res.data);
                    }
                });
            } else {
                resolve(this.cache[ys["appKey"]]);
            }
        }
    });
};
YSToken.prototype.getYsAccessToken = function(appKey, appSecret) {
    return new Promise((resovle, reject) => {
        instance({
            url: "https://open.ys7.com/api/lapp/token/get",
            method: "post",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            params: {
                appKey,
                appSecret
            }
        })
            .then(res => {
                if (res.status == 200) {
                    if (res.data.code == "200") {
                        resovle({
                            value: true,
                            data: res.data.data.accessToken
                        });
                    } else {
                        resovle({
                            value: false,
                            data: res.data.msg
                        });
                    }
                } else {
                    resovle({
                        value: false,
                        data: res.statusText
                    });
                }
            })
            .catch(err => {
                resovle({
                    value: false,
                    data: err.toString()
                });
            });
    });
};
YSToken.prototype.sendOrder = function(method, order, camera_device_id) {
    let methodMap = {
        mirror: "https://open.ys7.com/api/lapp/device/ptz/mirror",
        stop: "https://open.ys7.com/api/lapp/device/ptz/stop",
        start: "https://open.ys7.com/api/lapp/device/ptz/start"
    };
    return new Promise((resovle, reject) => {
        this.getToken(camera_device_id)
            .then(token => {
                let accessToken = token;
                instance({
                    url: methodMap[method],
                    method: "post",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    params: Object.assign(
                        {},
                        {
                            accessToken
                        },
                        order
                    )
                })
                    .then(res => {
                        if (res.status == 200) {
                            if (res.data.code == "200") {
                                resovle({
                                    value: true,
                                    data: res.data.msg
                                });
                            } else {
                                resovle({
                                    value: false,
                                    data: res.data.msg
                                });
                            }
                        } else {
                            resovle({
                                value: false,
                                data: res.statusText
                            });
                        }
                    })
                    .catch(err => {
                        resovle({
                            value: false,
                            data: err.toString()
                        });
                    });
            })
            .catch(err => {
                resovle({
                    value: false,
                    data: err
                });
            });
    });
};

function checkCameraIsH265(camera) {
    return new Promise((resolve, reject) => {
        if (camera.type != 1) {
            resolve(false);
        } else {
            if (!camera.appkey || !camera.appsecret) {
                resolve(false);
            } else {
                if (!camera.ezopen) {
                    resolve(false);
                } else {
                    resolve(true);
                }
            }
        }
    });
}

function checkYSCameraIsH265(url) {
    url = getHttps(url);
    return new Promise((resolve, reject) => {
        const H265Error = "/ErrTS/9053_0";
        const H405Error = "ErrTS/405_0";
        const H404Error = "ErrTS/404_0";
        fetch(url)
            .then(function(response) {
                return response.text();
            })
            .then(res => {
                if (res.includes(H265Error)) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            })
            .catch(err => {
                resolve(false);
            });
        setTimeout(() => {
            resolve(false);
        }, 1500);
    });
}

function getHttps(hls) {
    let newHls = hls;
    if (!newHls.includes("https")) {
        newHls = hls.replace("http", "https");
    }
    if (newHls.includes("lechange")) {
        newHls = newHls + "?proto=https";
        newHls = newHls.replace("8888", "8890");
    }
    return newHls;
}
var ys = new YSToken();
export { ys, checkCameraIsH265, getHttps };
// module.exports = YSToken
